import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  KCol,
  KRow,
  Label,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Support_ScreenBase } from "./support-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class Support_Screen extends Support_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{}}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <>
              <div
                key="-1"
                id="support_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(21, 27, 39, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    display: "block",
                  } as any
                }
              >
                <KRow
                  key="595398"
                  id="595398"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="942457"
                    id="942457"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <VerticalStack
                      key="956220"
                      id="956220"
                      direction="vertical"
                      size={4}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "rgba(255, 255, 255, 1)",
                        } as any
                      }
                    >
                      <Label
                        key="60722"
                        id="60722"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          60722,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderBottomWidth: 1,
                            borderColor: "rgba(185, 203, 224, 1)",
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "18px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="158308"
                        id="158308"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          158308,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="759819"
                        id="759819"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          759819,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="830234"
                        id="830234"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          830234,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="590678"
                        id="590678"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          590678,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="814980"
                        id="814980"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          814980,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="756591"
                        id="756591"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          756591,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="615164"
                        id="615164"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          615164,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="939558"
                        id="939558"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          939558,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="266658"
                        id="266658"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          266658,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="906580"
                        id="906580"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          906580,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="8515"
                        id="8515"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          8515,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                    </VerticalStack>
                  </KCol>
                </KRow>
                <KRow
                  key="783780"
                  id="783780"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="402157"
                    id="402157"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <VerticalStack
                      key="31683"
                      id="31683"
                      direction="vertical"
                      size={4}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "rgba(255, 255, 255, 1)",
                        } as any
                      }
                    >
                      <Label
                        key="306659"
                        id="306659"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          306659,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderBottomWidth: 1,
                            borderColor: "rgba(185, 203, 224, 1)",
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "18px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="282347"
                        id="282347"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          282347,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="901508"
                        id="901508"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          901508,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="462423"
                        id="462423"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          462423,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="716076"
                        id="716076"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          716076,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="609983"
                        id="609983"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          609983,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="7974"
                        id="7974"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          7974,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="73983"
                        id="73983"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          73983,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="19926"
                        id="19926"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          19926,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="18677"
                        id="18677"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          18677,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="299138"
                        id="299138"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          299138,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                      <Label
                        key="296357"
                        id="296357"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          296357,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "rgba(255, 255, 255, 1)",
                          } as any
                        }
                      ></Label>
                    </VerticalStack>
                  </KCol>
                </KRow>
              </div>
            </>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(Support_Screen)
        )
      )
    )
  )
);
export { tmp as Support_Screen };
//export default tmp;
//export { tmp as Support_Screen };
